
<div class="wm-property-container" #propertiesPanelComp>
  <div *ngIf="selectedWidgetsCount > 1" class="multi-select-container">
    <img [src]="('assets/images/autolayout/multi-select-icon.png' | versionManager)" alt="Multi-Select Icon" />
    <div class="multi-select-texts">
      <span class="multi-select-title">
        Multi-select mode
      </span>
      <span class="multi-select-msg">
        Auto layout will be applied to {{ selectedWidgetsCount }} items
      </span>
    </div>
    <button class="btn button-primary" (click)="applyAutoLayout()">Add Auto layout</button>
  </div>
  <div class="wm-properties" *ngIf="selectedWidgetsCount <= 1" ng-controller="PropertiesController">
  <div  class="activewidget-info" *ngIf="activeTab === 'DESIGN'">
     <p class="widget-info" *ngIf="activeWidget && activeWidget.name" title="{{activeWidget?.widgetType}}: {{activeWidget?.name}}">
        {{activeWidget?.widgetType}}: {{activeWidget?.name}}
     </p>
  </div>
  <div class="wm-properties" ng-controller="PropertiesController">
    <datalist id="list-date-patterns">
      <option *ngFor="let opt of datePatterns">{{opt}}</option>
    </datalist>
    <datalist id="list-time-patterns">
      <option *ngFor="let opt of timePatterns">{{opt}}</option>
    </datalist>
    <datalist id="list-eventlist">
      <!-- <option *ngFor="let opt of eventsList">{{opt}}</option> -->
    </datalist>
    <datalist id="list-date-time-patterns">
      <option *ngFor="let opt of calendarPatterns">{{opt}}</option>
    </datalist>

    <div class="property-top" [ngClass]="{'hide-properties-panel': !activeWidget?.widgetType}"
         *ngIf="activeTab === 'DESIGN' && activeWidget && activeWidget.widgetProps">
      <tabset class="wm-tabs">
        <!-- TODO:add name -->
        <ng-container *ngFor="let group of propertyGroups">
          <tab *ngIf="group.show" (selectTab)="onPropertyGroupTabSelect(group);group.active = true" [id]="group.name">
            <ng-template tabHeading>
              <i class="wm-icon {{group.iconClass}}" title="{{locale['LABEL_PROPERTY_' + group.name.toUpperCase()]}}"></i>
            </ng-template>

            <div class="node-properties" *ngIf="showProperties() && !(group.name==='security' && !liveWidgetSettingsService.isSecurityEnabled)"
                 init-if="group.active">
              <div class="wm-search-container" *ngIf="!((group.name === 'security') || (group.name ==='device'))">
                <!--<wms-search name="wm-search-widget-{{group.name}}" placeholder="{{::locale.LABEL_SEARCH + '...'}}" model="$group.searchProperty"
                            on-search="filterProperties(group, val, activeWidget.widgetProps)"
                            on-clear="filterProperties(group)"
                ></wms-search>-->
                <wms-search (onSearch)="filterPropertyByKey($event.searchKey, group)"></wms-search>
              </div>
              <div class="properties-list"
                   [ngClass]="{'disable-all': !preferences?.project?.pages?.edit}">
                <ng-container *ngFor="let subGroup of group.subGroups">
                  <div class="property-subgroup {{group.name}}" *ngIf="subGroup.show && subGroup.filteredProps?.length > 0">
                    <h4
                      class='property-subgroup-name'>{{locale[subGroup.displayKey] || locale['LABEL_PROPERTYGROUP_' + subGroup?.name?.toUpperCase()]}}</h4>
                    <ul>
                      <ng-container *ngFor="let property of subGroup.filteredProps; let Index=index">
                        <!-- TODO:add "&& !(activeWidget['bind'+property].toString().length > 0)" in ngclass to inline-prop -->
                        <!-- TODO: add property="{{property}}" -->
                        <li id="property-{{property}}" [wmsWidgetHelp]="property" [activeWidget]="activeWidget" class="property-{{property}}"
                            [ngClass]="{'property-long' : activeWidget.widgetProps[property]?.displayName,
                                    'disabled-property': activeWidget.widgetProps[property]?.disabled,
                                     'inline-block-prop': activeWidget.widgetProps[property]?.displaytype === 'inlineblock'  ,
                                     'inline-prop': (activeWidget.widgetProps[property]?.widget === 'checkbox' || activeWidget.widgetProps[property]?.type === 'boolean') && !(activeWidget['bind'+property]?.toString().length > 0)}"
                                     *ngIf="!!activeWidget.widgetProps[property]?.show && !activeWidget.widgetProps[property]?.showindesigner && (!activeWidget.widgetProps[property]?.parent || activeWidget.widgetProps[property]?.parent === subGroup.name)">
                                     <div class="property-label">
                                      <!-- TODO:add || (locale['LABEL_WIDGET_PROPERTY'][(activeWidget.widgettype !== 'wm-form-field' ? activeWidget.widgettype : 'wm-' + activeWidget.fieldDefConfig.widget)][property.toUpperCase()]) -->
                                      <label class="control-label" *ngIf="!(activeWidget.widgetProps[property]?.hidelabel || !activeWidget.widgetProps[property]?.show)"
                                      title="{{(activeWidget?.widgetType === 'wm-prefab' && (activeWidget.widgetProps[property]?.displayName || activeWidget.widgetProps[property]?.label || (property | capitalize)))
                                               || locale['LABEL_PROPERTY_' + activeWidget.widgetProps[property]?.label?.toUpperCase()]
                                               || locale[activeWidget.widgetProps[property]?.label]
                                               || activeWidget.widgetProps[property]?.displayName
                                               || locale[activeWidget.widgetProps[property]?.displayKey]
                                               || activeWidget.widgetProps[property]?.label
                                               || locale['LABEL_PROPERTY_' + property?.toUpperCase()]
                                               || (property | capitalize)}}">{{(activeWidget?.widgetType === 'wm-prefab' && (activeWidget.widgetProps[property]?.displayName || activeWidget.widgetProps[property]?.label || (property | capitalize)))
                            || locale['LABEL_PROPERTY_' + activeWidget.widgetProps[property]?.label?.toUpperCase()]
                            || locale[activeWidget.widgetProps[property]?.label]
                            || activeWidget.widgetProps[property]?.displayName
                            || locale[activeWidget.widgetProps[property]?.displayKey]
                            || activeWidget.widgetProps[property]?.label
                            || locale['LABEL_PROPERTY_' + property?.toUpperCase()]
                            || (property | capitalize)}}</label>
                          </div>
                          <i *ngIf="activeWidget.widgetProps[property]?.error" class="wm-icon error wms wms-error-outline"
                            title="{{activeWidget.widgetProps[property].errMsgDesc}}"></i>
                          <div class="property-value" *ngIf="(activeWidget['bind'+property]?.toString().length > 0)">
                            <input wmsExpressionError [expression]="shadowProperties[property]" type="text" class="form-control app-textbox bound-value" [(ngModel)]="shadowProperties[property]"
                              (focus)="setActiveProperty(property)"
                              [ngClass]="{'bound-value-disable': (activeWidget['bind'+property].indexOf('bind:Variables.') ===-1 && activeWidget['bind'+property].indexOf('bind:Variables[') ===-1)}"
                              (change)="shadowPropertyChange(property,shadowProperties[property])" [readonly]="true"
                              (click)="showVariableDialog(activeWidget['bind'+property].toString())" [attr.title]="activeWidget['bind'+property].toString()">
                            <i class="remove-binding-icon wms wms-clear" (click)="clearProperty(property)"></i>
                          </div>
                          <div class="property-value" *ngIf="activeWidget && activeWidget.widgetProps && !(activeWidget['bind'+property]?.toString().length > 0)">
                            <wms-properties-template [isPropPanel]="true" [activeWidget]="activeWidget" [property]="property" [shadowProperties]="shadowProperties" [widgetType]="activeWidget.widgetType" [widgetId]="activeWidget.widgetId || activeWidget.name"
                            [liveWidgetSettingsService]="liveWidgetSettingsService"
                            (openAdvancedSettings)="handleAdvancedSettingsClick($event)"></wms-properties-template>
                          </div>
                          <button name="wm-bind-property-{{property}}"
                                  *ngIf="activeWidget.widgetProps[property]?.bindable === 'in-bound' || activeWidget.widgetProps[property]?.bindable === 'in-out-bound' || activeWidget.widgetProps[property]?.bindable === true"
                                  (click)="openBindVariableDialog(activeWidget?.widgetProps[property], property, activeWidget?.widgetProps[property].bindContext)"
                                  [disabled]="activeWidget.widgetProps[property]?.disabled"
                                  class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
                                  <!-- For container widgets having content as a partial & partials have params -->
                          <div class="property-subgroup sub-properties" *ngIf="property==='content' && activeWidget.partialParams?.length">
                            <h4 class='property-subgroup-name'>{{locale.LABEL_PARTIAL_PARAMS}}</h4>
                            <ul>
                              <li *ngFor="let param of activeWidget.partialParams">
                                <label class="control-label param-label">{{param.name}}</label>
                                <div class="property-value" *ngIf="(param.value?.indexOf('bind:') !== 0)">
                                  <input type="text" class="form-control app-textbox"
                                         [(ngModel)]="param.value"
                                         [ngModelOptions]="{updateOn: 'change'}"
                                         (change)="onPartialParamValueChange(activeWidget)"/>
                                </div>
                                <div class="property-value" *ngIf="(param.value?.indexOf('bind:') === 0)">
                                  <input wmsExpressionError [expression]="param.value" type="text" class="form-control app-textbox bound-value"
                                         [ngClass]="{'bound-value-disable': (param.value?.indexOf('bind:Variables.') ===-1 && param.value?.indexOf('bind:Variables[') ===-1)}"
                                         [(ngModel)]="param.value" title="{{param.value}}" ng-readonly="true"/>
                                  <button class="wm-icon clear wms wms-clear remove-binding-icon" (click)="param.value=''; onPartialParamValueChange(activeWidget);"></button>
                                </div>
                                <button name="wm-bind-property-{{property}}"
                                        (click)="openBindVariableDialog({type: param.type, isSubProperty: true, value: param.value, propertyModel:param}, param.name)"
                                        class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                </ng-container>

                <div class="property-subgroup" *ngIf="activeWidget?.showServerProps && group.name === 'properties'">
                  <h4 class='property-subgroup-name'>
                    {{locale.LABEL_PROPERTYGROUP_SERVERPROPS}}
                  </h4>
                  <ul>
                    <li *ngFor="let prop of activeWidget?.serverProps | keyvalue">
                      <div class="property-label">
                        <label class="control-label">{{locale['LABEL_PROPERTY_' + $any(prop.key).toUpperCase()] || prop.key}}</label>
                      </div>
                      <div class="property-value">
                        <input type="text" class="form-control app-textbox" [(ngModel)]="activeWidget?.serverProps[$any(prop).key]"
                               (ngModelChange)="setAppPrefabServerProperty()"
                               [ngModelOptions]="{updateOn: 'blur'}">
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- Page Input Params block (visible only when 'wm-page' is selected)-->
                <div *ngIf="group.name === 'properties' && ((activeWidget?.widgetType === 'wm-page' && !isPrefabType) || activeWidget?.widgetType === 'wm-partial')"
                     class="property-subgroup">

                  <ul *ngIf="activeWidget?.widgetType === 'wm-page' && !isMobileApplicationType">
                    <li class="property-pagetitle" [wmsWidgetHelp]="'pagetitle'" [activeWidget]="activeWidget" property="pagetitle">
                      <div class="property-label">
                        <label class="control-label">{{locale.LABEL_PROPERTY_PAGETITLE }}</label>
                      </div>
                      <div class="property-value" *ngIf="activeWidget.pagetitle?.indexOf('bind:') === 0">
                        <input wmsExpressionError [expression]="activeWidget.pagetitle" type="text" class="form-control app-textbox bound-value" (focus)="setActiveProperty('pagetitle')"
                               [ngClass]="{'bound-value-disable': (activeWidget.pagetitle?.indexOf('bind:Variables.') ===-1 && activeWidget.pagetitle?.indexOf('bind:Variables[') ===-1)}"
                               readonly
                               (click)="showVariableDialog(activeWidget.pagetitle)"
                               value="{{activeWidget.pagetitle}}"
                               [attr.title]="activeWidget.pagetitle">
                        <i class="remove-binding-icon wms wms-clear" (click)="onPageTitleChange('')"></i>
                      </div>
                      <div class="property-value"  *ngIf="activeWidget.pagetitle?.indexOf('bind:') !== 0" >
                        <input class="form-control app-textbox" [(ngModel)]="activeWidget.pagetitle"
                               maxlength="100"
                               (change)="onPageTitleChange(activeWidget.pagetitle)">
                      </div>
                      <button name="wm-bind-property-pagetitle"
                              (click)="openBindVariableDialogForPageTitle()"
                              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
                    </li>
                  </ul>

                  <h4 class='property-subgroup-name'>
                    {{locale.LABEL_INPUT_PARAMS}}
                  </h4>
                  <div class="property-value property-table">
                    <table class="wm-table wm-table-dark">
                      <tbody>
                      <tr>
                        <th>{{locale.LABEL_NAME}}</th>
                        <th>{{locale.LABEL_TYPE}}</th>
                        <th>&nbsp;</th>
                      </tr>
                      <tr *ngFor="let param of pageWsService.pageParams; index as $index">
                        <td name="wm-input-param-{{param.name}}">
                          <input class="form-control app-textbox app-widget-wrapper"
                                 name="wm-input-param-name-{{param.name}}"
                                 type="text"
                                 placeholder="{{locale.PLACEHOLDER_PARAMETER_NAME}}"
                                 [ngModelOptions]="{updateOn: 'change'}"
                                 [(ngModel)]="param.name"
                                 (change)="pageWsService.onParamNameChange(param, '{{param.name}}');pageWsService.onPageParamsUpdate()">
                        </td>
                        <td>
                          <select name="wm-input-param-type-{{param.name}}" class="form-control app-select"
                                  [(ngModel)]="param.type"
                                  (change)="pageWsService.onPageParamsUpdate()">
                            <option *ngFor="let val of pageParamTypes"
                                    [selected]="param.type == val" value="{{val}}">{{val}}
                            </option>
                          </select>
                        </td>
                        <td>
                          <button name="wm-input-param-remove-{{param.name}}" (click)="pageWsService.pageParams.splice($index, 1); pageWsService.onPageParamsUpdate()" class="btn app-button btn-transparent">
                            <i class="wm-icon wms wms-delete"></i>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td name="wm-new-input-param">
                          <input class="form-control app-textbox app-widget-wrapper"
                                 name="wm-new-input-param-name"
                                 type="text"
                                 placeholder="{{locale.PLACEHOLDER_PARAMETER_NAME}}"
                                 [ngModelOptions]="{updateOn: 'change'}"
                                 [(ngModel)]="pageWsService.newParam.name">
                        </td>
                        <td>
                          <select name="wm-new-input-param-type" class="form-control app-select"
                                  [(ngModel)]="pageWsService.newParam.type">
                            <option *ngFor="let val of pageParamTypes"
                                    [selected]="pageWsService.newParam.type == val" value="{{val}}">{{val}}
                            </option>
                          </select>
                        </td>
                        <td>
                          <button name="wm-new-input-param-add" class="btn app-button btn-transparent"
                                  (click)="pageWsService.addNewParam(pageWsService.newParam)">
                            <i class="wm-icon wms wms-plus"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel noproperties-message" *ngIf="!(group.name==='security' && !liveWidgetSettingsService.isSecurityEnabled && activeWidget?.widgetType)">
              <div class="panel-body">
                <i class="fa fa-hand-o-left"></i>
                <p>{{locale.LABEL_SELECT_WIDGET_MESSAGE}}</p>
              </div>
            </div>
            <div class="panel noproperties-message show-message" *ngIf="group.name==='security' && !liveWidgetSettingsService.isSecurityEnabled && activeWidget?.widgetType">
                <div class="panel-body">
                  <p>{{locale.MESSAGE_ENABLE_SECURITY}}</p>
                </div>
            </div>
          </tab>
        </ng-container>
      </tabset>
    </div>
  </div>
</div>
<wms-dialog id="BindVariable" [content]="bindVariableDialog" customClasses="bind-variable-dialog wm-studio-dialog large wm-right-panel-container app-messages-dialog">
</wms-dialog>
<ng-template #bindVariableDialog>
  <wms-bind-dialog-ui (onModalClose)="closeDialogWithId('BindVariable')"></wms-bind-dialog-ui>
</ng-template>

<wms-dialog id="selectIconDialog" customClasses="wm-select-icon-dialog medium wm-studio-dialog" [content]="selectIconContent"></wms-dialog>
<ng-template #selectIconContent>
  <wms-icon-selector  [Icon]="activeWidget['iconclass']"  (handleChanges)="dialogParams($event.boundVariable, $event.boundProperty,$event.boundVariableType)"  (handleClose)="closeDialogWithId('selectIconDialog')" ></wms-icon-selector>
</ng-template>
